"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.not = exports.createDictValueCtr = exports.flattenDictionary = exports.Dictionary = void 0;
const utils_1 = require("@dev-stream/utils");
class Dictionary {
    constructor(ctrs, ...parts) {
        Object.assign(this, ...parts);
        Object.keys(this).forEach((key) => {
            if (!this[key]) {
                return;
            }
            const ctr = ctrs.find((c) => c.typeChecker(this[key]));
            if (!ctr) {
                return;
            }
            this[key] = new ctr.ctr(this[key]);
        });
    }
}
exports.Dictionary = Dictionary;
function flattenDictionary(dict) {
    if (dict == null) {
        return [];
    }
    return (0, utils_1.objectKeys)(dict).reduce((result, key) => [
        ...result,
        {
            key,
            value: dict[key],
        },
    ], []);
}
exports.flattenDictionary = flattenDictionary;
function createDictValueCtr(ctr, typeChecker) {
    if (Array.isArray(typeChecker)) {
        return {
            ctr,
            typeChecker: (obj) => typeChecker.reduce((prev, cur) => prev && cur(obj), true),
        };
    }
    return {
        ctr,
        typeChecker: typeChecker,
    };
}
exports.createDictValueCtr = createDictValueCtr;
function not(func) {
    return (obj) => !func(obj);
}
exports.not = not;
